import { allLanguageSelectOptions, countrySelectOptions, useRouter } from '@application/utils';
import type { CountryCode } from '@gql/graphql';
import {
  FiltersWithModalInputSelectField,
  FiltersWithModalInputWrapper,
} from '@presentation/components';
import { Form } from 'formik';
import type { FC } from 'react';
import type { FiltersProps } from './types';

export const Filters: FC<FiltersProps> = (props) => {
  const { options } = props;
  const { language, translate, countryCode } = useRouter();

  const countryOptions = countrySelectOptions(translate);

  return (
    <Form>
      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<CountryCode>
          name="countries"
          placeholder={translate('common.inputs.country.placeholder')}
          multiple
          dismissOnClick={false}
          options={countryOptions}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<string>
          name="regions"
          multiple
          dismissOnClick={false}
          placeholder={translate(`common.inputs.regions.placeholder.${countryCode}`)}
          options={options.regions}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<string>
          name="spokenLanguages"
          multiple
          placeholder={translate('common.inputs.spokenLanguages.placeholder')}
          options={allLanguageSelectOptions(language, ['fr', 'nl'])}
        />
      </FiltersWithModalInputWrapper>
    </Form>
  );
};
